import { memo, useMemo } from "react";

import { BasicInfoLabelWithTextLayout } from "../../layout";

type Props = {
	// 返金された金額
	refundedPriceByAdmin: number;
	// お客様の合計金額
	totalGuestCharge: number;
};

export const TotalGuestChargeOfBasicInfoCompositions = memo(({ refundedPriceByAdmin, totalGuestCharge }: Props) => {
	/**
	 * 返金された金額が存在するか
	 */
	const existRefundedPrice = useMemo(() => {
		return refundedPriceByAdmin > 0;
	}, [refundedPriceByAdmin]);
	/**
	 * 返金前の合計金額テキスト
	 */
	const totalGuestChargeBeforeRefundText = useMemo(() => {
		/**
		 * 返金されていれば、合計に返金された金額を足す
		 */
		const _totalGuestCharge = existRefundedPrice ? totalGuestCharge + refundedPriceByAdmin : totalGuestCharge;

		return `¥ ${_totalGuestCharge.toLocaleString()}`;
	}, [existRefundedPrice, refundedPriceByAdmin, totalGuestCharge]);
	/**
	 * 返金金額テキスト
	 */
	const refundedPriceByAdminText = useMemo(() => {
		return `¥ ${refundedPriceByAdmin.toLocaleString()}`;
	}, [refundedPriceByAdmin]);
	/**
	 * 支払い料金テキスト
	 */
	const totalGuestChargeText = useMemo(() => {
		return `¥ ${totalGuestCharge.toLocaleString()}`;
	}, [totalGuestCharge]);

	/**
	 * 返金金額の表示制御
	 */
	const canShowRefundedPrice = useMemo(() => {
		return existRefundedPrice;
	}, [existRefundedPrice]);

	return (
		<div className="space-y-1">
			{canShowRefundedPrice && (
				<>
					<BasicInfoLabelWithTextLayout
						label="返金前の合計金額"
						textChildren={<p>{totalGuestChargeBeforeRefundText}</p>}
					/>

					<BasicInfoLabelWithTextLayout
						label="宿泊後の返金金額"
						textChildren={<p>{refundedPriceByAdminText}</p>}
					/>
				</>
			)}
			<BasicInfoLabelWithTextLayout
				label="お客様のお支払い金額合計"
				textChildren={<p className="text-2xl font-bold">{totalGuestChargeText}</p>}
			/>
		</div>
	);
});
